/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Featureoff1Inputs */

const en_featureoff1 = /** @type {(inputs: Featureoff1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`off`)
};

const de_featureoff1 = /** @type {(inputs: Featureoff1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aus`)
};

/**
* | output |
* | --- |
* | "off" |
*
* @param {Featureoff1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const featureoff1 = /** @type {((inputs?: Featureoff1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Featureoff1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_featureoff1(inputs)
	return de_featureoff1(inputs)
});
export { featureoff1 as "featureOff" }